export const categories = [
    { name: "Artificial Intelligence", icon: "spark" },
    { name: "Screen Control", icon: "monitor" },
    { name: "System Monitoring", icon: "pulse" },
    { name: "Linux Apps", icon: "terminal" },
    { name: "Windows Apps", icon: "window" },
    { name: "Books & PDFs", icon: "book" },
    { name: "Visual Assets", icon: "image" },
];
export const products = [
    {
        id: "prd_qcore_screen",
        slug: "qcore-screen-commander",
        name: "QCore Screen Commander",
        shortName: "Screen Commander",
        category: "Screen Control",
        platform: "Cross-platform",
        description: "A disciplined remote-screen command surface with clear status, bounded control and recovery-aware sessions.",
        priceUsd: 19,
        priceBdt: 2250,
        version: "1.0.0",
        featured: true,
        tags: ["remote", "screen", "command"],
        accent: "#74d8c3",
        status: "published",
    },
    {
        id: "prd_guardian",
        slug: "guardian-system-monitor",
        name: "Guardian System Monitor",
        shortName: "Guardian Monitor",
        category: "System Monitoring",
        platform: "Linux",
        description: "A calm operational dashboard for health, load, storage, services and early-warning signals.",
        priceUsd: 12,
        priceBdt: 1450,
        version: "1.2.0",
        featured: true,
        tags: ["monitoring", "health", "linux"],
        accent: "#a8d991",
        status: "published",
    },
    {
        id: "prd_linux_garden",
        slug: "linux-garden-toolkit",
        name: "Linux Garden Toolkit",
        shortName: "Linux Toolkit",
        category: "Linux Apps",
        platform: "Linux",
        description: "A compact collection of safe maintenance, backup and workflow utilities for Linux workstations.",
        priceUsd: 9,
        priceBdt: 1050,
        version: "2.0.1",
        featured: false,
        tags: ["linux", "utilities", "backup"],
        accent: "#e7c878",
        status: "published",
    },
    {
        id: "prd_ai_field",
        slug: "ai-field-notebook",
        name: "AI Field Notebook",
        shortName: "AI Notebook",
        category: "Artificial Intelligence",
        platform: "Web",
        description: "Turn questions, documents and evolving ideas into structured missions, decisions and reusable knowledge.",
        priceUsd: 15,
        priceBdt: 1750,
        version: "0.9.0",
        featured: true,
        tags: ["ai", "notes", "research"],
        accent: "#da9cc8",
        status: "published",
    },
    {
        id: "prd_strategy_book",
        slug: "field-insight-handbook",
        name: "Field Insight Handbook",
        shortName: "Insight Handbook",
        category: "Books & PDFs",
        platform: "PDF",
        description: "A concise digital handbook for observing systems, separating signal from noise and acting with foresight.",
        priceUsd: 5,
        priceBdt: 590,
        version: "1st edition",
        featured: true,
        tags: ["ebook", "insight", "strategy"],
        accent: "#ef9f82",
        status: "published",
    },
    {
        id: "prd_visual_kit",
        slug: "garden-interface-kit",
        name: "Garden Interface Kit",
        shortName: "Garden UI Kit",
        category: "Visual Assets",
        platform: "Cross-platform",
        description: "Original cards, panels, backgrounds and interface tokens for calm premium digital products.",
        priceUsd: 8,
        priceBdt: 950,
        version: "1.0.0",
        featured: false,
        tags: ["design", "ui", "assets"],
        accent: "#90b9e8",
        status: "published",
    },
];
export const libraryItems = [
    { id: "lib_1", slug: "architecture-of-calm-systems", title: "The Architecture of Calm Systems", type: "Book", description: "Why robust systems reduce uncertainty before adding capability.", readingMinutes: 34, access: "Public" },
    { id: "lib_2", slug: "decision-maps", title: "Decision Maps for Complex Missions", type: "Guide", description: "A practical method for dependencies, gates and bounded fallback.", readingMinutes: 18, access: "Member" },
    { id: "lib_3", slug: "sovereign-digital-workspace", title: "Sovereign Digital Workspace", type: "Research", description: "Local-first architecture, controlled cloud use and resilient personal infrastructure.", readingMinutes: 27, access: "Public" },
    { id: "lib_4", slug: "garden-city-notes", title: "Garden City Notes", type: "Collection", description: "A growing collection of visual, technical and strategic observations.", readingMinutes: 52, access: "Paid" },
];
export const insights = [
    { id: "idea_1", title: "Personal software should explain its state", stage: "Building", summary: "Interfaces become trustworthy when they show what is happening, why and what happens next.", updatedAt: "2026-07-21" },
    { id: "idea_2", title: "A marketplace can feel like a place", stage: "Designing", summary: "Commerce, knowledge and identity can share one coherent spatial language without becoming cluttered.", updatedAt: "2026-07-20" },
    { id: "idea_3", title: "AI subscriptions need mission-weighted limits", stage: "Researching", summary: "Simple internal units protect cost while keeping the customer experience understandable.", updatedAt: "2026-07-18" },
];
export const aiPlans = [
    { id: "free", name: "Free", priceUsd: 0, monthlyUnits: 150, routes: ["Quick"], features: ["5 quick requests daily", "Public city knowledge", "Short answers"] },
    { id: "plus", name: "Plus", priceUsd: 5, monthlyUnits: 1200, routes: ["Quick", "Smart"], features: ["Document summaries", "Chat history", "Purchased-product support"] },
    { id: "pro", name: "Pro", priceUsd: 20, monthlyUnits: 6000, routes: ["Quick", "Smart", "Deep", "Vision"], highlight: true, features: ["Deep research", "Private knowledge space", "Image and document analysis"] },
    { id: "max", name: "Max", priceUsd: 30, monthlyUnits: 12000, routes: ["Quick", "Smart", "Deep", "Vision"], features: ["Largest usage pool", "Multiple knowledge spaces", "Priority processing"] },
];
export const formatMoney = (value, currency = "USD") => new Intl.NumberFormat(currency === "USD" ? "en-US" : "bn-BD", {
    style: "currency",
    currency,
    maximumFractionDigits: currency === "USD" ? 2 : 0,
}).format(value);
export const slugify = (value) => value.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
//# sourceMappingURL=index.js.map